import { formatDate, formatMoney } from '../domain/format';

/**
 * `etaDate`/`completedRange` are epoch milliseconds, unlike UtilsUi.formatDate's
 * seconds. In the app's language: "Aug 11, 2026" / "11 ago 2026" / "11 de ago. de 2026".
 */
export function formatCampaignDate(epochMs: number, lang: string | undefined): string {
  return formatDate(epochMs, lang, { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * The cost of one result, as money in the app's language ("$3.09" / "$3,09"):
 * the same "$" and two decimals as every other amount of the feature.
 */
export function formatCostPerResult(
  costPerResult: number | null,
  lang: string | undefined,
): string | null {
  if (costPerResult === null) return null;
  return formatMoney(costPerResult, lang);
}
